import { useState } from "react";

export default function AskSocietyExpert({ docId, onOpenPage }) {
  const [question, setQuestion] = useState("");
  const [lang, setLang] = useState("HI");
  const [loading, setLoading] = useState(false);
  const [answer, setAnswer] = useState("");
  const [citations, setCitations] = useState([]);

  const ask = async () => {
    setLoading(true);
    setAnswer("");
    setCitations([]);
    try {
      const r = await fetch(`${process.env.REACT_APP_FUNCTIONS_API}/legal/ask`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ docId, question, language: lang }),
      });
      const j = await r.json();
      if (!j.ok) throw new Error(j.error || "Failed");
      setAnswer(j.answer || "");
      setCitations(j.citations || []);
    } catch (e) {
      setAnswer("Error: " + (e.message || "Ask failed"));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="bg-white rounded-2xl border shadow-sm p-4 space-y-3">
      <div className="flex items-center justify-between gap-2">
        <div className="font-extrabold text-slate-900 text-sm">🤖 Ask Society Expert</div>
        <select className="border rounded-lg px-2 py-1 text-sm" value={lang} onChange={(e) => setLang(e.target.value)}>
          <option value="HI">Hindi</option>
          <option value="GU">Gujarati</option>
          <option value="EN">English</option>
        </select>
      </div>

      <textarea
        value={question}
        onChange={(e) => setQuestion(e.target.value)}
        className="w-full min-h-[90px] px-3 py-2 rounded-xl border"
        placeholder="Ask anything from this Act/Bylaws (e.g., Board election ka process?)"
      />

      <button
        onClick={ask}
        disabled={loading || !question.trim()}
        className="w-full px-4 py-2 rounded-xl bg-slate-900 text-white font-semibold disabled:opacity-60"
      >
        {loading ? "Answering…" : "Get Answer"}
      </button>

      {answer ? (
        <div className="text-sm whitespace-pre-wrap text-slate-800 bg-slate-50 border rounded-xl p-3">
          {answer}
        </div>
      ) : null}

      {citations?.length ? (
        <div className="space-y-2">
          <div className="text-xs font-bold text-slate-600">References</div>
          <div className="flex flex-wrap gap-2">
            {citations.map((c, i) => {
              const label = c.pageTo && c.pageTo !== c.pageFrom ? `Page ${c.pageFrom}-${c.pageTo}` : `Page ${c.pageFrom}`;
              return (
                <button
                  key={i}
                  onClick={() => onOpenPage?.(c.pageFrom || 1)}
                  className="text-xs px-2 py-1 rounded-full border bg-white hover:bg-slate-50"
                  title={c.snippet || ""}
                >
                  {label}
                </button>
              );
            })}
          </div>
        </div>
      ) : null}
    </div>
  );
}
